import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from '../../common/services/base.service';
import { Branch } from '../../common/interfaces/branch.interface';
import { PhoneNumber } from '../../common/interfaces/phone-number.interface';

@Injectable()
export class CommonBranchService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    findAll(opCo: string): Observable<Branch[]> {
        let params = new HttpParams();
        params = params.append('opcoCode', opCo);
        params = params.append('selfPickupAndReturnAvailable', 'true');

        return this.http.get(this.getApiUrl('branchOffices') + '/branch-offices', {params})
            .pipe(
                map((res: any) => res || []),
                map((branches: Branch[]) => branches.map((branch: Branch) =>
                    ({
                        ...branch,
                        phone: PhoneNumber.fromData(branch.phone as string),
                        serviceDepartmentPhone: PhoneNumber.fromData(branch.serviceDepartmentPhone as string)
                    })
                ))
            );
    }

    findOne(code: string, opCo: string): Observable<Branch> {
        let params = new HttpParams();
        params = params.append('opcoCode', opCo);
        return this.http.get(this.getApiUrl('branchOffices') + '/branch-offices/' + code, {params})
            .pipe(
                map((res: any) => res || {}),
                map((branch: Branch) => ({
                        ...branch,
                        phone: PhoneNumber.fromData(branch.phone as string),
                        serviceDepartmentPhone: PhoneNumber.fromData(branch.serviceDepartmentPhone as string)
                    })
                ));
    }
}
